import { extendObservable } from 'mobx';
import CampaignSearchStore from './CampaignSearchStore';

class UiState {
  constructor(railsProps) {
    this.campaignSearch = CampaignSearchStore;

    extendObservable(this, {
      category: railsProps.category,
    });
  }
}

export default UiState;
